import { Client, Product, PickingItem, Order, OrderItem, OrderStatus } from '../../types/orders';
import { calculateItemTotals, calculateOrderSummary } from '../taxCalculations';

// Mock Clients - B2B and B2C
export const mockClients: Client[] = [
  {
    id: 'c1',
    name: 'Vidraçaria São Paulo LTDA',
    cnpj: '12.345.678/0001-90',
    uf: 'SP',
    address: 'Av. Paulista, 1000 - São Paulo/SP',
    isConsumerFinal: false,
    email: 'contato@vidracariasp.com.br',
    phone: '(11) 3456-7890',
  },
  {
    id: 'c2',
    name: 'João Carlos da Silva',
    cnpj: '123.456.789-00',
    uf: 'MG',
    address: 'Rua das Flores, 123 - Belo Horizonte/MG',
    isConsumerFinal: true,
    email: 'joaocarlos@email.com',
    phone: '(31) 98765-4321',
  },
  {
    id: 'c3',
    name: 'Esquadrias Curitiba S/A',
    cnpj: '98.765.432/0001-21',
    uf: 'PR',
    address: 'Rua XV de Novembro, 500 - Curitiba/PR',
    isConsumerFinal: false,
    email: 'vendas@esquadriascwb.com.br',
    phone: '(41) 3333-4444',
  },
  {
    id: 'c4',
    name: 'Maria Fernanda Oliveira',
    cnpj: '987.654.321-00',
    uf: 'RJ',
    address: 'Av. Atlântica, 2000 - Rio de Janeiro/RJ',
    isConsumerFinal: true,
    email: 'mfoliveira@email.com',
    phone: '(21) 99876-5432',
  },
];

// Mock Products from spreadsheet data
export const mockProducts: Product[] = [
  {
    id: 'p1',
    codePreference: 'S-240020-7H6H6',
    codeOmie: '240020-7H6H60BS058',
    color: 'NOGAL',
    description: 'ST60 Marco 53 x 60 mm Nogal PX (M)',
    system: 'ST60',
    ncm: '3916.20.00',
    packagingUnit: 23.20,
    unit: 'm',
    fraction: 5.80,
    tablePrice: 74.02,
    ipiRate: 6.5,
    icmsOrigin: 1, // Importado
    unitWeight: 0.835,
    group: 1,
  },
  {
    id: 'p2',
    codePreference: 'S-240020-7H7H7',
    codeOmie: '240020-7H7H70BS058',
    color: 'PRETO',
    description: 'ST60 Marco 53 x 60 mm Black CC+ (M)',
    system: 'ST60',
    ncm: '3916.20.00',
    packagingUnit: 23.20,
    unit: 'm',
    fraction: 5.80,
    tablePrice: 77.67,
    ipiRate: 6.5,
    icmsOrigin: 1,
    unitWeight: 0.835,
    group: 1,
  },
  {
    id: 'p3',
    codePreference: 'S-240020-B0000',
    codeOmie: '240020-B00000BM058',
    color: 'BRANCO',
    description: 'ST60 Marco 53 x 60 mm White (M)',
    system: 'ST60',
    ncm: '3916.20.00',
    packagingUnit: 23.20,
    unit: 'm',
    fraction: 5.80,
    tablePrice: 51.32,
    ipiRate: 6.5,
    icmsOrigin: 0, // Nacional
    unitWeight: 0.835,
    group: 1,
  },
  {
    id: 'p4',
    codePreference: 'S-241040-7H6H6',
    codeOmie: '241040-7H6H60BS058',
    color: 'NOGAL',
    description: 'ST60 Folha Abertura int. Porta 100 x 60 mm Nogal PX (M)',
    system: 'ST60',
    ncm: '3916.20.00',
    packagingUnit: 23.20,
    unit: 'm',
    fraction: 5.80,
    tablePrice: 118.85,
    ipiRate: 6.5,
    icmsOrigin: 1,
    unitWeight: 1.302,
    group: 1,
  },
  {
    id: 'p5',
    codePreference: 'S-241040-B0000',
    codeOmie: '241040-B00000BM058',
    color: 'BRANCO',
    description: 'ST60 Folha Abertura int. Porta 100 x 60 mm White (M)',
    system: 'ST60',
    ncm: '3916.20.00',
    packagingUnit: 23.20,
    unit: 'm',
    fraction: 5.80,
    tablePrice: 76.91,
    ipiRate: 6.5,
    icmsOrigin: 0,
    unitWeight: 1.302,
    group: 1,
  },
  {
    id: 'p6',
    codePreference: 'S-416301-7H60',
    codeOmie: '416301-7H6000B0058',
    color: 'NOGAL',
    description: 'Tapajuntas/vista 60mm Nogal PX - Sendo perfil de arremate',
    system: 'ST60',
    ncm: '3916.20.00',
    packagingUnit: 34.80,
    unit: 'm',
    fraction: 5.80,
    tablePrice: 43.63,
    ipiRate: 6.5,
    icmsOrigin: 1,
    unitWeight: 0.343,
    group: 1,
  },
  {
    id: 'p7',
    codePreference: 'S-242020-7H6H6',
    codeOmie: '242020-7H6H60BS058',
    color: 'NOGAL',
    description: 'ST60 Poste em T 70 x 60 mm Nogal PX (M)',
    system: 'ST60',
    ncm: '3916.20.00',
    packagingUnit: 23.20,
    unit: 'm',
    fraction: 5.80,
    tablePrice: 87.21,
    ipiRate: 6.5,
    icmsOrigin: 1,
    unitWeight: 0.941,
    group: 1,
  },
  {
    id: 'p8',
    codePreference: 'S-242310-B0000',
    codeOmie: '242310-B00000BM058',
    color: 'BRANCO',
    description: 'ST60 Perfil Universal 30 x 60 mm White (M)',
    system: 'ST60',
    ncm: '3916.20.00',
    packagingUnit: 34.80,
    unit: 'm',
    fraction: 5.80,
    tablePrice: 44.18,
    ipiRate: 6.5,
    icmsOrigin: 0,
    unitWeight: 0.689,
    group: 1,
  },
];

// Mock Orders
let itemCounter = 1;
function createMockOrderItem(product: Product, quantity: number, paymentCondition: 'cash' | 'credit', discount: number, uf: string, isB2C: boolean): OrderItem {
  const calculated = calculateItemTotals(product, quantity, paymentCondition, discount, uf, isB2C);
  return {
    id: `item-${itemCounter++}`,
    productId: product.id,
    product,
    ...calculated,
  };
}

export const mockOrders: Order[] = [
  {
    id: 'order1',
    number: '00001',
    clientId: mockClients[0].id,
    client: mockClients[0],
    orderType: 'b2b',
    paymentCondition: 'cash',
    items: [
      createMockOrderItem(mockProducts[0], 46.40, 'cash', 0, mockClients[0].uf, false),
      createMockOrderItem(mockProducts[2], 23.20, 'cash', 0, mockClients[0].uf, false),
      createMockOrderItem(mockProducts[3], 69.60, 'cash', 5, mockClients[0].uf, false),
    ],
    subtotalProducts: 0,
    totalIpi: 0,
    totalIcms: 0,
    totalDifal: 0,
    freight: 150.00,
    totalWeight: 0,
    grandTotal: 0,
    status: 'pending' as OrderStatus,
    createdAt: new Date('2025-02-05T10:00:00'),
    updatedAt: new Date('2025-02-05T10:00:00'),
  },
  {
    id: 'order2',
    number: '00002',
    clientId: mockClients[1].id,
    client: mockClients[1],
    orderType: 'b2c',
    paymentCondition: 'credit',
    items: [
      createMockOrderItem(mockProducts[1], 34.80, 'credit', 0, mockClients[1].uf, true),
      createMockOrderItem(mockProducts[4], 46.40, 'credit', 10, mockClients[1].uf, true),
    ],
    subtotalProducts: 0,
    totalIpi: 0,
    totalIcms: 0,
    totalDifal: 0,
    freight: 0,
    totalWeight: 0,
    grandTotal: 0,
    status: 'draft' as OrderStatus,
    createdAt: new Date('2025-02-06T14:30:00'),
    updatedAt: new Date('2025-02-06T14:30:00'),
  },
  {
    id: 'order3',
    number: '00003',
    clientId: mockClients[2].id,
    client: mockClients[2],
    orderType: 'b2b',
    paymentCondition: 'credit',
    items: [
      createMockOrderItem(mockProducts[5], 58.00, 'credit', 0, mockClients[2].uf, false),
      createMockOrderItem(mockProducts[6], 23.20, 'credit', 0, mockClients[2].uf, false),
      createMockOrderItem(mockProducts[7], 34.80, 'credit', 0, mockClients[2].uf, false),
    ],
    subtotalProducts: 0,
    totalIpi: 0,
    totalIcms: 0,
    totalDifal: 0,
    freight: 200.00,
    totalWeight: 0,
    grandTotal: 0,
    status: 'invoiced' as OrderStatus,
    createdAt: new Date('2025-02-03T09:15:00'),
    updatedAt: new Date('2025-02-04T16:45:00'),
  },
  {
    id: 'order4',
    number: '00004',
    clientId: mockClients[3].id,
    client: mockClients[3],
    orderType: 'b2c',
    paymentCondition: 'cash',
    items: [
      createMockOrderItem(mockProducts[0], 23.20, 'cash', 0, mockClients[3].uf, true),
      createMockOrderItem(mockProducts[2], 11.60, 'cash', 0, mockClients[3].uf, true),
    ],
    subtotalProducts: 0,
    totalIpi: 0,
    totalIcms: 0,
    totalDifal: 0,
    freight: 50.00,
    totalWeight: 0,
    grandTotal: 0,
    status: 'picking' as OrderStatus,
    createdAt: new Date('2025-02-07T08:00:00'),
    updatedAt: new Date('2025-02-07T08:00:00'),
  },
];

// Calcular totais para cada pedido mockado
mockOrders.forEach((order) => {
  const summary = calculateOrderSummary(order.items, order.client.uf, order.orderType === 'b2c');
  order.subtotalProducts = summary.subtotalProducts;
  order.totalIpi = summary.totalIpi;
  order.totalIcms = summary.totalIcms;
  order.totalDifal = summary.totalDifal;
  order.totalWeight = summary.totalWeight;
  order.grandTotal = summary.subtotalProducts + summary.totalIpi + summary.totalDifal + order.freight;
});

// Mock Picking Items for Logistics Screen
export const mockPickingItems: PickingItem[] = [
  {
    id: 'pick1',
    orderId: 'order1',
    orderNumber: '00001',
    product: mockProducts[0],
    quantity: 46.40,
    quantityInThisShipment: 46.40,
    location: { corridor: 'A', column: 3, height: 2 },
    picked: false,
  },
  {
    id: 'pick2',
    orderId: 'order1',
    orderNumber: '00001',
    product: mockProducts[2],
    quantity: 23.20,
    quantityInThisShipment: 23.20,
    location: { corridor: 'A', column: 5, height: 1 },
    picked: false,
  },
  {
    id: 'pick3',
    orderId: 'order1',
    orderNumber: '00001',
    product: mockProducts[3],
    quantity: 69.60,
    quantityInThisShipment: 69.60,
    location: { corridor: 'B', column: 1, height: 3 },
    picked: true,
    pickedAt: new Date('2025-01-30T10:30:00'),
  },
  {
    id: 'pick4',
    orderId: 'order1',
    orderNumber: '00001',
    product: mockProducts[5],
    quantity: 34.80,
    quantityInThisShipment: 34.80,
    location: { corridor: 'C', column: 2, height: 1 },
    picked: false,
  },
];
